import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const neweldworldConfig: TSPConfig = {
  key: 'neweldworld',
  name: 'NewELDWorld',
  category: TSPCategory.CREDENTIALS,
  helpText: 'Please provide your NewELDWorld credentials.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
      ]}
    />
  ),
};

export default neweldworldConfig;
